<div class="error">
    <h1>418 - I'm a Teapot</h1>
    <mat-icon>local_cafe</mat-icon>
    <p>
        This server is semantically proven to be a teapot.
        <br>
        A teapot cannot brew coffee, please ask for a coffee machine.
    </p>
    <a routerLink="/">Go back to Home</a>
</div>